module.exports = __webpack_public_path__ + "fonts/SF-Pro-Display-Heavy.a545fc03.otf";